import { render, staticRenderFns } from "./user-audit.vue?vue&type=template&id=c9bfd1c4&scoped=true&"
import script from "./user-audit.vue?vue&type=script&lang=js&"
export * from "./user-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bfd1c4",
  null
  
)

export default component.exports